export const DEFAULT_PAGE_NUMBER = 1
export const DEFAULT_PAGE_SIZE = 10
export const ALGOLIA_FIRST_PAGE_NUMBER = 0

export const DEBOUNCE_INPUT_SEARCH_DELAY = 700
